import {graphql} from 'react-relay'

export const query = graphql`
  query QueuePageQuery($locator: String!, $skip: Boolean!) {
    agentPoolRest(agentPoolLocator: $locator) @skip(if: $skip) {
      ...QueuePageHeader_agentPool
    }
  }
`
